import { buildControllerRules } from '@gettactic/helpers/src/hook-form/buildControllerRules';
import React from 'react';
import { Controller, FieldValues } from 'react-hook-form';
import { SelectInput } from './SelectInput';
import { HookFormSelectInputProps } from './SelectInput.types';

export const HookFormSelectInput = <T extends FieldValues>({
  form,
  name,
  rules,
  onChange,
  ...props
}: HookFormSelectInputProps<T>): React.ReactElement => {
  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired: props.isRequired
      })}
      render={({ field, fieldState }) => (
        <SelectInput
          ref={field.ref}
          onChange={onChange}
          {...props}
          value={field.value}
          onChangeValue={(value) => {
            field.onChange(value);
            //@ts-expect-error We can't use onChange this way because is supposed to receive an event. TODO @jason -- how did you plan to bind onchange to this?
            onChange?.(value);
          }}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
